import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, AlertCircle, Loader2, ArrowRight } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export default function LeadUnsubscribe() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [state, setState] = useState({ status: "loading", email: "", message: "" });

    useEffect(() => {
        if (!token) {
            setState({ status: "error", message: "Kein Abmelde-Token gefunden." });
            return;
        }
        api.post("/leads/unsubscribe", { token })
            .then((r) => {
                setState({
                    status: "success",
                    email: r.data.email || "",
                    message: "Sie haben sich erfolgreich abgemeldet. Wir senden Ihnen keine weiteren Mails.",
                });
            })
            .catch((err) => {
                setState({
                    status: "error",
                    message: formatApiError(err.response?.data?.detail) || "Abmeldung fehlgeschlagen.",
                });
            });
    }, [token]);

    const Icon = state.status === "loading" ? Loader2 : state.status === "error" ? AlertCircle : CheckCircle2;
    const tone = {
        loading: "bg-aimploy-violet/10 text-aimploy-violet",
        success: "bg-emerald-50 text-emerald-700",
        error: "bg-red-50 text-red-700",
    }[state.status];

    return (
        <div className="min-h-[70vh] flex items-center justify-center p-6" data-testid="lead-unsubscribe-page">
            <div className="max-w-lg w-full bg-white rounded-3xl p-10 lg:p-12 border border-black/5 text-center">
                <div className={`mx-auto h-16 w-16 rounded-full ${tone} flex items-center justify-center mb-6`}>
                    <Icon className={`w-7 h-7 ${state.status === "loading" ? "animate-spin" : ""}`} />
                </div>
                <h1 className="font-display text-3xl lg:text-4xl font-bold mb-4">
                    {state.status === "loading" && "Bearbeite Abmeldung…"}
                    {state.status === "success" && "Abgemeldet"}
                    {state.status === "error" && "Hm, das hat nicht geklappt"}
                </h1>
                <p className="text-aimploy-muted mb-2" data-testid="lead-unsubscribe-message">{state.message}</p>
                {state.email && <p className="text-sm text-aimploy-muted mb-8 font-mono">{state.email}</p>}
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 mt-6 bg-aimploy-navy hover:bg-aimploy-navy-hover text-white px-6 py-3 rounded-full text-sm font-semibold transition-colors"
                >
                    Zurück zur Startseite <ArrowRight className="w-4 h-4" />
                </Link>
            </div>
        </div>
    );
}
